import { JsonProperty, JsonObject } from "typescript-json-serializer";

@JsonObject()
export class HubjectProvider {
    @JsonProperty('UserId') userId: string;
    @JsonProperty('Email') email: string;
}
